import { render, staticRenderFns } from "./ConfigGroup.vue?vue&type=template&id=3540cf27&"
import script from "./ConfigGroup.vue?vue&type=script&lang=js&"
export * from "./ConfigGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VDivider,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader})
